import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

const Splash = () => <h1> The splash </h1>;
const Flow = () => <h1> The flow </h1>;
const Success = () => <h1> The success </h1>;
export default function App() {
  const { pathname: url } = useLocation();

  return (
    <Routes>
      <Route index={true} element={<Navigate to={`${url}/splash`} />} />
      <Route path="/splash" element={<Splash />} />
      <Route path="/flow" element={<Flow />} />
      <Route path="/success" element={<Success />} />
    </Routes>
  );
}
